import { CheckCircle, XCircle, Clock, AlertCircle } from "lucide-react";
import { Badge } from "../ui/badge";

// Reusable component for rendering a test item
export const TestItem = ({ test, result }) => {
  const status = result?.status || 'waiting';
  
  const getStatusIcon = () => {
    switch (status) {
      case 'pass':
        return <CheckCircle className="h-4 w-4 text-green-600" />;
      case 'fail':
        return <XCircle className="h-4 w-4 text-red-600" />;
      case 'warning':
        return <AlertCircle className="h-4 w-4 text-yellow-600" />;
      default:
        return <Clock className="h-4 w-4 text-gray-400" />;
    }
  };

  const getStatusBadge = () => {
    switch (status) {
      case 'pass':
        return <Badge className="bg-green-600 text-white">Pass</Badge>;
      case 'fail':
        return <Badge className="bg-red-600 text-white">Fail</Badge>;
      case 'warning':
        return <Badge className="bg-yellow-600 text-white">Warning</Badge>;
      default:
        return <Badge className="bg-gray-400 text-white">Waiting...</Badge>;
    }
  };

  return (
    <div
      className={`flex items-center justify-between p-3 rounded-lg border ${
        status === 'pass' ? 'bg-green-50 border-green-200' :
        status === 'fail' ? 'bg-red-50 border-red-200' :
        status === 'warning' ? 'bg-yellow-50 border-yellow-200' :
        'bg-gray-50 border-gray-200'
      }`}
    >
      <div className="flex items-center gap-3">
        {getStatusIcon()}
        <div>
          <p className="font-medium text-sm">{test.name}</p>
          {result?.message && status !== 'waiting' && (
            <p className="text-xs text-gray-600 mt-1">{result.message}</p>
          )}
        </div>
      </div>
      {getStatusBadge()}
    </div>
  );
};

// Reusable component for rendering a subsection of tests
export const TestSubsection = ({ icon: Icon, title, badge, tests, results, iconColor }) => {
  return (
    <div className="pt-6 first:pt-0">
      <div className="flex items-center gap-2 mb-4">
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <h3 className="font-semibold text-base">{title}</h3>
        {badge && badge}
      </div>
      <div className="space-y-2">
        {tests.map((test) => {
          const result = results.find(r => r.name === test.name);
          return <TestItem key={test.id} test={test} result={result} />;
        })}
      </div>
    </div>
  );
};
